import React, { useState, FC } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Entry, EntryFields } from 'contentful';
import { BLOCKS, Document } from '@contentful/rich-text-types';
import { Body } from '@sumup-oss/circuit-ui';

import {
  ExpandableAccordionContainer,
  AccordionContent,
  AccordionTitle,
  AccordionIcon,
  AccordionElement,
} from '../styled';

// eslint-disable-next-line import/no-cycle
import { ACCORDION_OPTIONS } from 'constants/richTextRendererOptions';

type AccordionEntryData = {
  name: string;
  label: string;
  // Need to enforce type for body.nodeType
  // Otherwise, we get the below error
  // Type '"document"' is not assignable to type 'BLOCKS.DOCUMENT'. ts(2345)
  body: EntryFields.RichText & {
    nodeType: BLOCKS.DOCUMENT;
  } & Document;
};

type AccordionEntryProps = {
  accordionEntryData: Entry<AccordionEntryData>;
};
const AccordionEntry: FC<AccordionEntryProps> = ({ accordionEntryData }) => {
  const [isOpened, setIsOpened] = useState(false);
  const handleClick = () => setIsOpened(!isOpened);

  return accordionEntryData.fields ? (
    <AccordionElement>
      <AccordionTitle onClick={handleClick}>
        <Body size="m">{accordionEntryData.fields.label}</Body>
        <AccordionIcon isOpened={isOpened} />
      </AccordionTitle>
      <ExpandableAccordionContainer isOpened={isOpened}>
        <AccordionContent>
          {documentToReactComponents(
            accordionEntryData.fields.body,
            ACCORDION_OPTIONS,
          )}
        </AccordionContent>
      </ExpandableAccordionContainer>
    </AccordionElement>
  ) : null;
};

export default AccordionEntry;
